import React, { useEffect, useState } from "react";
import PageHeader from "../../../../components/common/PageHeader";
import { useNavigate, useParams } from "react-router-dom";
import { convertToInquiry, getFollowupList } from "../api/followup.api";
import { VERTICALS } from "../../../../constants/verticals";
import { toast } from "react-toastify";
import "../styles/followup.css";

const FollowupList = () => {
    const navigate = useNavigate();
    const { vertical } = useParams<{ vertical: string }>();

    const verticalConfig = VERTICALS.find(v => v.key === vertical);
    const verticalId = verticalConfig?.id;
    const verticalName = verticalConfig?.label;

    const [list, setList] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [openMenuId, setOpenMenuId] = useState<number | null>(null);
    const [filters, setFilters] = useState({
        client_name: "",
        contact: "",
        stage: "",
        status: "",
    });
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

    const toggleMenu = (id: number, event: any) => {
        event.stopPropagation();

        const rect = event.currentTarget.getBoundingClientRect();

        setMenuPosition({
            top: rect.bottom + window.scrollY,
            left: rect.left + window.scrollX,
        });

        setOpenMenuId(prev => (prev === id ? null : id));
    };

    const fetchFollowups = async () => {
        try {
            if (!verticalId) return;

            const res = await getFollowupList(page, {
                vertical_id: verticalId, // ✅ FIXED
                ...filters,
            });

            setList(res.data?.results?.data || []);
            setTotalCount(res.data?.results?.count || 0);
        } catch (err) {
            console.error(err);
            toast.error("Failed to load followups");
        }
    };

    useEffect(() => {
        fetchFollowups();
    }, [page, verticalId, filters]);

    const handleConvertToInquiry = async (id: number) => {
        try {
            if (!verticalId) return;

            await convertToInquiry(id, verticalId);

            toast.success("Converted to Inquiry successfully");

            setOpenMenuId(null);

            fetchFollowups(); // refresh

        } catch (err: any) {
            toast.error(err?.response?.data?.message || "Conversion failed");
        }
    };
    useEffect(() => {
        const handleClickOutside = () => setOpenMenuId(null);
        document.addEventListener("click", handleClickOutside);

        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    
    return (
        <>
            <PageHeader
                title={`${verticalName} – Sales Followup`}
                breadcrumbs={[
                    { label: "Home" },
                    { label: "Sales" },
                    { label: verticalName || "" },
                    { label: "Followups" },
                ]}
            />

            <div className="container mt-4">
                <div className="info-card">

                    {/* HEADER */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4>{verticalName} – Followup List</h4>
                    </div>

                    {/* TABLE */}
                    <div className="inquiry-table-wrapper table-responsive">
                        <table className="table inquiry-table align-middle">

                            {/* HEADER */}
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "center" }}>Action</th>
                                    <th>Source</th>
                                    <th>Client Segment</th>
                                    <th>Stage</th>
                                    <th>Owner</th>
                                    <th>Assigned To</th>
                                    <th>Created Date</th>
                                    <th>Status</th>
                                </tr>

                                {/* FILTER ROW */}
                                <tr className="inquiry-filter-row">
                                    <th></th>

                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search"
                                            onChange={(e) =>
                                                setFilters((prev: any) => ({
                                                    ...prev,
                                                    source_name: e.target.value,
                                                }))
                                            }
                                        />
                                    </th>

                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search"
                                            onChange={(e) =>
                                                setFilters((prev: any) => ({
                                                    ...prev,
                                                    client_segment: e.target.value,
                                                }))
                                            }
                                        />
                                    </th>

                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search"
                                            onChange={(e) =>
                                                setFilters((prev: any) => ({
                                                    ...prev,
                                                    stage: e.target.value,
                                                }))
                                            }
                                        />
                                    </th>

                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search"
                                            onChange={(e) =>
                                                setFilters((prev: any) => ({
                                                    ...prev,
                                                    owner: e.target.value,
                                                }))
                                            }
                                        />
                                    </th>

                                    <th>
                                        <input
                                            className="form-control form-control-sm"
                                            placeholder="Search"
                                            onChange={(e) =>
                                                setFilters((prev: any) => ({
                                                    ...prev,
                                                    assigned_to: e.target.value,
                                                }))
                                            }
                                        />
                                    </th>

                                    <th>-</th>
                                    <th>-</th>
                                </tr>
                            </thead>

                            {/* BODY */}
                            <tbody>
                                {list.length === 0 ? (
                                    <tr>
                                        <td colSpan={8} className="text-center py-4">
                                            No followups found
                                        </td>
                                    </tr>
                                ) : (
                                    list.map((row: any) => (
                                        <tr key={row.id}>

                                            {/* ACTION */}
                                            <td style={{ position: "relative", textAlign: "center" }}>
                                                <button
                                                    className="inquiry-action-btn"
                                                    onClick={(e) => toggleMenu(row.id, e)}
                                                >
                                                    ⋮
                                                </button>

                                            </td>

                                            <td>{row.source_name || "-"}</td>
                                            <td>{row.client_segment_name || "-"}</td>
                                            <td>{row.enquiry_stage_name || "-"}</td>
                                            <td>{row.owner_name || "-"}</td>
                                            <td>{row.assigned_to_name || "-"}</td>

                                            <td style={{ textAlign: "center" }}>
                                                {row.date_created
                                                    ? new Date(row.date_created).toLocaleDateString("en-GB")
                                                    : "-"}
                                            </td>

                                            <td>
                                                <span className="badge bg-success">
                                                    Followup
                                                </span>
                                            </td>

                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                        {openMenuId && (
                            <div
                                className="inquiry-action-dropdown"
                                style={{
                                    position: "fixed",
                                    top: menuPosition.top,
                                    left: menuPosition.left,
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div
                                    className="dropdown-item"
                                    onClick={() => {
                                        navigate(`/${vertical}/followups/${openMenuId}/edit`);
                                    }}
                                >
                                    Edit Followup
                                </div>
                                <div
                                    className="dropdown-item"
                                    onClick={() => handleConvertToInquiry(openMenuId)}
                                >
                                    Convert to Inquiry
                                </div>

                            </div>
                        )}
                    </div>

                    {/* PAGINATION */}
                    <div className="d-flex justify-content-end mt-3 gap-2">
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            disabled={page === 1}
                            onClick={() => setPage(page - 1)}
                        >
                            Prev
                        </button>

                        <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => setPage(page + 1)}
                        >
                            Next
                        </button>
                    </div>

                </div>
            </div>
        </>
    );
};

export default FollowupList;